module.exports = __webpack_public_path__ + "img/connection-icon.30a9f893.svg";